module.exports = __webpack_public_path__ + "media/images/pages/get-involved/elizabeth-fe597385d7a60dc0c31dce2f351f0255.png";